const teamNl = {
  save: "Opslaan",
  cancel: "Annuleren",
  english: "English",
  french: "French",
  dutch: "Dutch",
  yes: "Ja",
  no: "Nee",
  economic_budget_updated_successfully: "Economisch budget succesvol bijgewerkt"
};
export default teamNl;
